import { Trash2 } from 'lucide-react';

import type { Thread } from './thread-store';

const formatUpdated = (iso: string): string => {
  const date = new Date(iso);
  return Number.isNaN(date.getTime())
    ? ''
    : new Intl.DateTimeFormat('sv-SE', { dateStyle: 'medium', timeStyle: 'short' }).format(date);
};

export const ThreadHistory = ({
  threads,
  activeId,
  onOpen,
  onDelete,
}: {
  threads: Thread[];
  activeId: string | null;
  onOpen: (threadId: string) => void;
  onDelete: (threadId: string) => void;
}) => (
  <div className="rounded-xl border border-black/10 bg-white shadow-sm">
    <div className="border-b border-black/10 px-4 py-2 text-xs uppercase tracking-wider text-text-grey">
      Tidigare frågor på den här datorn
    </div>
    {threads.length === 0 ? (
      <p className="px-4 py-3 text-sm text-text-grey">Inga sparade frågor än.</p>
    ) : (
      <ul className="max-h-64 divide-y divide-black/5 overflow-y-auto">
        {threads.map((thread) => (
          <li
            key={thread.id}
            className={`flex items-center gap-3 px-4 py-2 ${
              thread.id === activeId ? 'bg-brand-beige-tint-2/60' : ''
            }`}
          >
            <button
              type="button"
              onClick={() => onOpen(thread.id)}
              className="min-w-0 flex-1 text-left"
            >
              <span className="block truncate text-sm text-brand-blue">{thread.title}</span>
              <span className="block text-xs text-text-grey">
                {formatUpdated(thread.updatedAt)} · {thread.entries.length} meddelanden
              </span>
            </button>
            <button
              type="button"
              onClick={() => onDelete(thread.id)}
              aria-label={`Ta bort frågan ${thread.title}`}
              className="shrink-0 rounded-sm p-1.5 text-text-grey transition-colors hover:bg-brand-beige-tint-2 hover:text-brand-sale-red"
            >
              <Trash2 className="h-4 w-4" />
            </button>
          </li>
        ))}
      </ul>
    )}
  </div>
);
